export function randomize(e) {
  let currentIndex = e.length,
    randomIndex

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--

    // And swap it with the current element.
    ;[e[currentIndex], e[randomIndex]] = [e[randomIndex], e[currentIndex]]
  }

  return e
}
